import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const KnowledgeCenter = Loadable(lazy(() => import('views/dashboard/KnowledgeCenter/KnowledgeCenter')));
const KnowledgeCenterSettings = Loadable(lazy(() => import('views/dashboard/KnowledgeCenter/KnowledgeCenterSettings')));
const ChannelNotifications = Loadable(lazy(() => import('views/dashboard/socialMedia/ChannelNotifications.jsx')));
const VideoDetailPage = Loadable(lazy(() => import('views/dashboard/socialMedia/VideoDetailPage.jsx')));
const InstagramPostDetailPage = Loadable(lazy(() => import('views/dashboard/socialMedia/InstagramPostDetailPage.jsx')));
const LinkedInPostDetailPage = Loadable(lazy(() => import('views/dashboard/socialMedia/LinkedInPostDetailPage.jsx')));
const IdeasPage = Loadable(lazy(() => import('views/dashboard/socialMedia/IdeasPage')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const PortfolioReview = Loadable(lazy(() => import('views/dashboard/PortfolioReview/index.jsx')));
const KnowledgeBaseDetail = Loadable(lazy(() => import('views/dashboard/KnowledgeCenter/components/KnowledgeBaseDetail')));
const KnowledgeGraphDashboard = Loadable(lazy(() => import('views/dashboard/index.jsx')));

const TrackingSettings = Loadable(lazy(() => import('views/dashboard/socialMedia/TrackingSettings')));
const Mattermost = Loadable(lazy(() => import('views/dashboard/Mattermost/Mattermost')));
const InternalKitCorner = Loadable(lazy(() => import('views/dashboard/InternalKitCorner/InternalKitCorner')));
const MFRankingHome = Loadable(lazy(() => import('views/dashboard/MFRanking/MFRankingHome.jsx')));
const MFRankingSettings = Loadable(lazy(() => import('views/dashboard/MFRanking/MFRankingSettings.jsx')));
const ClientPasswords = Loadable(lazy(() => import('views/dashboard/ClientPasswords/index.jsx')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="/brain" replace />
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />
    },
    {
      path: '/knowledge-center/graph',
      element: <KnowledgeGraphDashboard />
    },
    {
      path: 'knowledge-center',
      element: <KnowledgeCenter />
    },
    {
      path: 'knowledge-center/settings',
      element: <KnowledgeCenterSettings />
    },
    {
      path: 'knowledge-center/:kbId',
      element: <KnowledgeBaseDetail />
    },
    {
      path: 'knowledge-center/:kbId/chat',
      element: <KnowledgeBaseDetail />
    },
    {
      path: 'mattermost',
      element: <Mattermost />
    },
    {
      path: 'internal-kit-corner',
      element: <InternalKitCorner />
    },
    {
      path: 'social',
      children: [
        {
          index: true,
          element: <TrackingSettings />
        },
        {
          path: 'add-channel',
          element: <TrackingSettings />
        },
        {
          path: 'channel/:channelId/notifications',
          element: <ChannelNotifications />
        },
        {
          path: 'videos/:videoId',
          element: <VideoDetailPage />
        },
        {
          path: 'posts/:postId',
          element: <InstagramPostDetailPage />
        },
        {
          path: 'linkedin-posts/:postId',
          element: <LinkedInPostDetailPage />
        },
        {
          path: 'ideas',
          element: <IdeasPage />
        }
      ]
    },
    {
      path: 'portfolio',
      element: <PortfolioReview />
    },
    {
      path: 'client-passwords',
      element: <ClientPasswords />
    },
    {
      path: 'mf-ranking',
      element: <MFRankingHome />
    },
    {
      path: 'mf-ranking/settings',
      element: <MFRankingSettings />
    }
  ]
};

export default MainRoutes;
